import localeData from './locale-data.json';

export default { ...localeData } as Record<string, string>;
